export default __webpack_public_path__ + "static/assets/81a73e23922a8d7b298626f4e0e4f8d8.png";